import $ from 'jquery';

import widgetFactory from '../widgetFactory';

const widgetName = 'slidingItem';

const widget = widgetFactory(widgetName, {
  options: {},

  _create: function () {
    var self = this;
    this._super();

    this.bgIllustrationImage = new Image();
    this.image = new Image();

    this.unveil = false;

    window.scrollMonitor.create(this.element[0]).one('enterViewport', function (element) {
      if (!self.unveil) {
        setTimeout(function () {
          self._loadBackground();
          self.unveil = true;
        }, 1);
      }
    });
  },

  _loadBackground: function () {
    var loadingClass = 'courseListItem__illustration--loading',
      $backgroundElement = $('.js-illustration', this.element),
      $imageElement = $('.js-image', this.element),
      bgUrl = $backgroundElement.data('imgUrl'),
      imgUrl = $imageElement.data('imgUrl');

    if (bgUrl || imgUrl) {
      $backgroundElement.addClass(loadingClass);
    }

    if (bgUrl) {
      this.bgIllustrationImage.onload = function () {
        $backgroundElement.css('background-image', 'url(' + this.src + ')');
        $backgroundElement.removeClass(loadingClass);
      };
      this.bgIllustrationImage.src = bgUrl;
    } else if (imgUrl) {
      this.image.onload = function () {
        $imageElement.attr('src', this.src);
        $backgroundElement.removeClass(loadingClass);
      };
      this.image.src = imgUrl;
    }
  },
});

export default widget;
